import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CiiPredictiveAllowanceModalComponent } from './cii-predictive-allowance-modal.component';

@NgModule({
  declarations: [CiiPredictiveAllowanceModalComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [CiiPredictiveAllowanceModalComponent]
})
export class CiiPredictiveAllowanceModalModule { }
